export function normalizeDashboardTrial (trial) {
  if (!trial || typeof trial !== 'object') return { days: 0, autoStart: false }
  const days = Number.isFinite(Number(trial.days))
    ? Math.max(0, Math.min(365, Math.floor(Number(trial.days))))
    : 0
  return {
    days,
    autoStart: days > 0 ? trial.autoStart !== false : false
  }
}

export function serializeDashboardTrial ({ days, autoStart } = {}) {
  const parsed = Number.parseInt(days, 10)
  if (Number.isNaN(parsed) || parsed < 0 || parsed > 365) {
    throw new Error('Trial days must be an integer between 0 and 365.')
  }
  return {
    days: parsed,
    autoStart: parsed > 0 ? autoStart !== false : false
  }
}
